



import React, { useState } from "react";
import {
  Box,
  Paper,
  ClickAwayListener,
  MenuItem,
  IconButton,
  Checkbox,
} from "@mui/material";
import arrow from "../assets/arrow.svg";
import crossselect from "../assets/crossselect.svg";
import CustomText, { textStyles } from "./CustomText";
import { useTranslation } from "react-i18next";

const SelectDropdown = ({ label, name, values, onChange, options, multiple = false }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  // normalize options
  const normalizedOptions = options.map((opt) =>
    typeof opt === "string" ? { label: opt, value: opt } : opt
  );

  const handleToggle = (option) => {
    let updated;
    if (multiple) {
      // Multiple selection mode
      updated = values.includes(option.value)
    ? values.filter((item) => item !== option.value)
        : [...values, option.value];
    } else {
      // Single selection mode
      updated = values.includes(option.value)
        ? []
        : [option.value];
    }

  onChange({ target: { name, value: updated } });

    if (!multiple) {
      setOpen(false); // Close dropdown after single selection
    }
};

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Box sx={{ position: "relative", mb: 0.5 }}>
        {label && (
          <CustomText
            sx={{
              ...textStyles.body5,
              color: "#6B778C",
              pt: 1.2,
              textAlign: "left",
            }}
          >
            {label}
          </CustomText>
        )}

        <Box
          onClick={() => setOpen(!open)}
          sx={{
            height: 38,
            border: "2px solid #091E4224",
            borderRadius: "6px",
            px: 2,
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            backgroundColor: "#fff",
            mt: 0.5,
          }}
        >
          <span style={{ color: values.length ? "#172B4D" : "#A0A0A0" }}>
            {values.length > 0 && multiple
              ? values
                  .map((val) => {
                    const option = normalizedOptions.find((o) => o.value === val);
                    return option ? option.label : val;
                  })
                  .join(", ")
              : values.length > 0 && !multiple
              ? normalizedOptions.find((o) => o.value === values[0])?.label || values[0]
              : t("select")}
          </span>
          <img src={arrow} alt="arrow" style={{ width: 18 }} />
        </Box>

        {open && (
          <Paper
            sx={{
              mt: 1,
              boxShadow: 1,
              borderRadius: 1,
              position: "absolute",
              zIndex: 10,
              width: "100%",
              p: 1,
              backgroundColor: "white",
              maxHeight: 150,
              overflowY: "auto",
            }}
          >
            {normalizedOptions.map((opt) => {
              const isSelected = values.includes(opt.value);
              return (
                <MenuItem
                  key={opt.value}
                  onClick={() => handleToggle(opt)}
                  sx={{
                    px: 1,
                    py: 0.5,
                    fontSize: "15px",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 400,
                    lineHeight: 1.2,
                    minHeight: "unset",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  {multiple && (
                    <Checkbox
                      checked={isSelected}
                      size="small"
                      sx={{
                        padding: 0,
                        color: "#006EC2",
                        "&.Mui-checked": {
                          color: "#006EC2",
                        },
                      }}
                    />
                  )}
                  {opt.label}
                </MenuItem>
              );
            })}
          </Paper>
        )}

        {values.length > 0 && (
          <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.8 }}>
            {values.map((val) => {
              const option = normalizedOptions.find((o) => o.value === val);
              return (
                <Box
                  key={val}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    px: 0.8,
                    py: 1,
                    backgroundColor: "#579DFF",
                    borderRadius: "6px",
                    fontSize: "14px",
                    color: "#09326C",
                    fontWeight: 500,
                  }}
                >
                  {option ? option.label : val}
                  <IconButton
                    size="small"
                    onClick={() => handleToggle(option || { value: val })}
                    sx={{ ml: 0.3, p: 0 }}
                  >
                    <img
                      src={crossselect}
                      alt="remove"
                      style={{ width: 16, height: 16 }}
                    />
                  </IconButton>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </ClickAwayListener>
  );
};

export default SelectDropdown;
